import {Component, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'app-report-trips',
  templateUrl: './report-trips.component.html',
  styleUrls: ['./report-trips.component.scss']
})
export class ReportTripsComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/pages/manager-reports/report-trips/report-trips.component.ts